import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import CascadiaCodeRegular from "./CascadiaCode.ttf";

export const CascadiaCodeFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: CascadiaCodeRegular,
  },
];
